import {SharedQuestion} from "./SharedQuestion";

export class ForceRankSharedQuestion extends SharedQuestion {

    protected values:IValue[] = [];

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        if (!this.question.required) {
            return true;
        }

        const countChoices = this.question.meta.choices ? this.question.meta.choices.length : 2;

        return countChoices === this.values.length;
    }

    validationMessage():string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'force_rank_validation_message';
    }

    getValue():IValue[] {
        return this.values;
    }

    setValue(value:IValue) {
        for (let oldValue of this.values) {
            if (oldValue.choice === value.choice) {
                oldValue.row = value.row;
                return;
            }
        }

        this.values.push(value);
    }

    satisfiesValue(currentValues:IValue[], value:IValue): boolean {
        for (let currentValue of currentValues) {
            if (currentValue.row === value.row && currentValue.choice === value.choice) {
                return value.value;
            }
        }

        // value doesn't exists which means that it is false
        // if node wants it to be false then it satisfies logic
        return !value.value;
    }
}